type ShelfItem = Record<string, unknown>;

export const normalizeRawProductValues = (
    values: Record<string, unknown>
): void => {
    // --- Drawer face default ---
    if (values.drawer_face_type == null) {
        const isAdvancedDoor = Number(values.job_cabinet_door_advanced) === 1;
        values.drawer_face_type = isAdvancedDoor ? 1 : 2;
    }

    // --- Border width aliases ---
    values.drawer_border_width_top = values.border_width_top;
    values.drawer_border_width_bottom = values.border_width_bottom;
    values.drawer_border_width_left = values.border_width_left;
    values.drawer_border_width_right = values.border_width_right;

    // --- Panel edge aliases ---
    values.drawer_panel_edge_top = values.panel_edge_top;
    values.drawer_panel_edge_bottom = values.panel_edge_bottom;
    values.drawer_panel_edge_left = values.panel_edge_left;
    values.drawer_panel_edge_right = values.panel_edge_right;

    // --- Split-cabinet dimension aliases ---
    values.cabinet_left_width = values.width2;
    values.cabinet_right_width = values.width;
    values.cabinet_left_depth = values.width_depth;
    values.cabinet_right_depth = values.length_depth;

    // --- Partition alias ---
    values.vertical_partition = values.cabinet_partition_width;

    // --- Rail amount aliases ---
    values.hori_amount = values.hori_amount ?? 0;
    values.vert_amount = values.vert_amount ?? 0;
    values.no_vert_bars = values.no_vert_bars ?? 0;
    values.no_hori_bars = values.no_hori_bars ?? 0;
    values.bar_width = values.bar_width ?? 0;
    values.hori_mid_rail_positions = values.hori_mid_rail_positions ?? [];
    values.vert_mid_rail_positions = values.vert_mid_rail_positions ?? [];

    // --- Upper shelf flat arrays derived from upper_shelves objects ---
    const upperShelves = Array.isArray(values.upper_shelves)
        ? (values.upper_shelves as ShelfItem[])
        : [];
    if (upperShelves.length > 0) {
        values.upper_shelf_type ??= upperShelves.map(
            (s) => s.upper_shelf_type ?? 5
        );
        values.upper_shelf_style ??= upperShelves.map(
            (s) => s.upper_shelf_style ?? 1
        );
        values.upper_shelf_position ??= upperShelves.map(
            (s) => s.upper_shelf_position ?? 0.5
        );
        values.upper_shelf_offset ??= upperShelves.map(
            (s) => s.upper_shelf_offset ?? 5
        );
    }

    // --- Lower shelf flat arrays derived from lower_shelves objects ---
    const lowerShelves = Array.isArray(values.lower_shelves)
        ? (values.lower_shelves as ShelfItem[])
        : [];
    if (lowerShelves.length > 0) {
        values.lower_shelf_type ??= lowerShelves.map(
            (s) => s.lower_shelf_type ?? 5
        );
        values.lower_shelf_style ??= lowerShelves.map(
            (s) => s.lower_shelf_style ?? 1
        );
        values.lower_shelf_position ??= lowerShelves.map(
            (s) => s.lower_shelf_position ?? 0.5
        );
        values.lower_shelf_offset ??= lowerShelves.map(
            (s) => s.lower_shelf_offset ?? 5
        );
    }
};
